import { render } from "./multiselect.vue?vue&type=template&id=aa22af5c&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"

import "./multiselect.vue?vue&type=style&index=0&id=aa22af5c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa22af5c"]])

export default __exports__